"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNetlify = exports.isVercel = void 0;
var generic_1 = __importDefault(require("./platform/generic"));
var vercel_1 = __importDefault(require("./platform/vercel"));
var netlify_1 = __importDefault(require("./platform/netlify"));
exports.isVercel = process.env.AXIOM_INGEST_ENDPOINT || process.env.NEXT_PUBLIC_AXIOM_INGEST_ENDPOINT;
exports.isNetlify = process.env.NETLIFY == 'true';
// Detect the platform provider, and return the appropriate config
// fallback to generic config if no provider is detected
var config = new generic_1.default();
if (exports.isVercel) {
    config = new vercel_1.default();
}
else if (exports.isNetlify) {
    config = new netlify_1.default();
}
exports.default = config;
//# sourceMappingURL=config.js.map